//#region IMPORT
import React, { useState, useRef, useEffect, useCallback } from 'react';
import { flushSync } from 'react-dom';
import { useDispatch, useSelector } from 'react-redux';
import {
  setDepList,
  setDepCd,
  setSearchText,
  setYear,
  setMonth,
} from '../../../Reducer/SearchReducer';
import { showSnackbar } from '../../../Reducer/SnackbarReducer';
import Commons from '../../../Services/Common/Common';
import Global from '../../../Services/Common/Global';
import { apiRequest } from '../../../Services/Common/ApiRequest';
import { mapParamsBySchema } from '../../../util';
import { GON_BASIC_Schema } from '../../BasicInfo/Gongjong/GON_BASIC/GON_BASIC_Schema';
import { useSearch1, useSave1, useDelete1 } from './RIN_DAI_QUERY';
import RIN_DAI from './RIN_DAI';
import { RIN_DAI_Schema, mapGetAcsBasic02R1RowToGrid } from './RIN_DAI_Schema';
import useDelete from '../../../hooks/useDeleteN';
import { useSave } from '../../../hooks/useSaveN';
import usePartialRefresh from '../../../hooks/usePartialRefresh';
import {
  closeLoading as closeLoadingAction,
  showLoading as showLoadingAction,
} from '../../../Reducer/LoadingReducer';
import dayjs from 'dayjs';
import FileUploadMultiDialog from '../../../Components/FileUploadDialog/FileUploadMultiDialog';
import useFileUpload from '../../../hooks/useFileUpload';
import useCompanyCustDep from '../../../hooks/useCompanyCustDep';
//#endregion

//#region 상수
const SCREEN_MENU_ID = 'RiskNearMiss';
//#endregion

function RIN_DAIF() {
  //#region 변수
  const dispatch = useDispatch();
  const { userInfo } = useSelector((state) => state.BaseInfo);
  const searchInfo = useSelector((state) => state.SearchInfo);
  const gridRef1 = useRef();
  const rowClickData = useRef(null);
  const gongjongRowDataRef = useRef(null);
  const selectedRowNosRef1 = useRef(new Set());
  const lastCheckedIndexRef1 = useRef(null);
  const executed = useRef(false);

  const [rowData1, setRowData1] = useState([]);
  const [selectedRowData1, setSelectedRowData1] = useState([]);
  const [changedRowData1, setChangedRowData1] = useState([]);
  const [deletedRowData1, setDeletedRowData1] = useState([]);
  const [modalToggle1, setModalToggle1] = useState(false);
  const [gongjongModalToggle, setGongjongModalToggle] = useState(false);
  const [preImageModalOpen, setPreImageModalOpen] = useState(false);
  const [postImageModalOpen, setPostImageModalOpen] = useState(false);
  const [preImageInitialFiles, setPreImageInitialFiles] = useState([]);
  const [postImageInitialFiles, setPostImageInitialFiles] = useState([]);
  const preImageRowRef = useRef(null);
  const postImageRowRef = useRef(null);

  const [searchClick1, setSearchClick1] = useState(false);
  const [saveClick1, setSaveClick1] = useState(false);
  const [printClick1, setPrintClick1] = useState(false);

  const [gongjongList, setGongjongList] = useState([]);
  const [gongjongCd, setGongjongCd] = useState('');

  const {
    handleCoChange,
    handleCustChange,
    handleDepChange,
    validateSelection: validateSelectionBase,
  } = useCompanyCustDep({
    requireCompany: true,
    requireCust: true,
    autoFetchDep: true,
    autoFetchDepDefaultAll: true,
  });

  const validateSelection = () => {
    if (!validateSelectionBase()) return false;
    return true;
  };

  const fetchDepForCust = useCallback(
    async (custCd) => {
      if (!custCd) return;
      try {
        const encryptedParams = mapParamsBySchema({
          CustCd: (_, context) => Commons.EncryptAES(custCd || '') || '',
          SearchText: (_, context) => Commons.EncryptAES('') || '',
        });
        const result = await apiRequest(
          'post',
          Global.urls.Utility.getDepLast,
          encryptedParams
        );
        const data = result?.data;
        let depList = [];
        if (data?.length > 0 && data[0]?.type !== 'Error') {
          depList = data.map((item) => ({
            name: item.depNmLast,
            value: item.depCd,
          }));
        }
        dispatch(setDepList(depList));
        dispatch(setDepCd(''));
      } catch (e) {
        console.error(e);
        dispatch(setDepList([]));
        dispatch(setDepCd(''));
      }
    },
    [dispatch]
  );

  const fetchGongjongForDep = useCallback(
    async (depCd) => {
      try {
        if (depCd) {
          const params = mapParamsBySchema(GON_BASIC_Schema.mapper.search2, {
            depCd,
          });
          const res = await apiRequest(
            'post',
            Global.urls.Gongjong.getGonBasicR1,
            params
          );
          const raw = res?.Data ?? res?.data ?? res;
          const list = Array.isArray(raw) ? raw : [];
          const nextList = list.map((r) => ({
            value: r.GongjongCd ?? r.gongjongCd ?? '',
            name: r.GongjongNm ?? r.gongjongNm ?? '',
          }));
          setGongjongList([{ value: '', name: '전체' }, ...nextList]);
        } else {
          const depList = searchInfo?.depList ?? [];
          if (depList.length === 0) {
            setGongjongList([{ value: '', name: '전체' }]);
            setGongjongCd('');
            return;
          }
          const results = await Promise.all(
            depList.map((dep) => {
              const depCdVal = dep.value ?? dep.depCd ?? '';
              if (!depCdVal) return Promise.resolve([]);
              const params = mapParamsBySchema(
                GON_BASIC_Schema.mapper.search2,
                {
                  depCd: depCdVal,
                }
              );
              return apiRequest(
                'post',
                Global.urls.Gongjong.getGonBasicR1,
                params
              ).then((res) => {
                const raw = res?.Data ?? res?.data ?? res;
                return Array.isArray(raw) ? raw : [];
              });
            })
          );
          const merged = results.flat();
          const seen = new Set();
          const nextList = merged
            .filter((r) => {
              const cd = r.GongjongCd ?? r.gongjongCd ?? '';
              if (seen.has(cd)) return false;
              seen.add(cd);
              return true;
            })
            .map((r) => ({
              value: r.GongjongCd ?? r.gongjongCd ?? '',
              name: r.GongjongNm ?? r.gongjongNm ?? '',
            }));
          setGongjongList([{ value: '', name: '전체' }, ...nextList]);
        }
        setGongjongCd('');
      } catch (e) {
        console.error(e);
        setGongjongList([]);
        setGongjongCd('');
      }
    },
    [searchInfo?.depList]
  );

  const handleGongjongChange = useCallback((value) => {
    setGongjongCd(value ?? '');
  }, []);

  const handleYearMonthChange = (date) => {
    const d = date ? dayjs(date) : dayjs();
    dispatch(setYear(d.format('YYYY')));
    dispatch(setMonth(d.format('MM')));
  };

  const buildInitialFilesFromImages = (images, imgType) => {
    const list = (images ?? []).filter(
      (img) => (img.ImgType ?? img.imgType) === imgType
    );
    return list.map((img) => {
      const fullPath = img.ImageFilePath ?? img.imageFilePath ?? '';
      const fileName = img.ImageFileName ?? img.imageFileName ?? '';
      const previewUrl = fullPath
        ? Global.file.useUrl + 'files/' + Commons.EncodeUrl(fullPath)
        : '';
      return { fileName, previewFilePath: fullPath, previewUrl };
    });
  };

  const buildInitialFilesFromRow = (
    folderPath,
    fileNamesStr,
    saveNamesStr,
    folderType = 'Pre'
  ) => {
    const custCd = searchInfo?.custCd || '';
    const displayNames = String(fileNamesStr || '')
      .split('|')
      .filter(Boolean);
    if (displayNames.length === 0) return [];

    const resolvedFolder =
      folderPath || `AccidentStatus/${custCd}/ACS_BASIC_02/${folderType}`;
    const saveNames = saveNamesStr
      ? String(saveNamesStr).split('|').filter(Boolean)
      : displayNames;
    const names = saveNames.length > 0 ? saveNames : displayNames;

    return names.map((saveName, i) => {
      const fullPath = `${resolvedFolder}/${saveName}`;
      const previewUrl =
        Global.file.useUrl + 'files/' + Commons.EncodeUrl(fullPath);
      return {
        fileName: displayNames[i] ?? saveName,
        previewFilePath: fullPath,
        previewUrl,
      };
    });
  };

  /** PreviewFiles 등 실제 서버 경로(| 구분) — 그리드 저장 전 재오픈 시 미리보기용 */
  const buildInitialFilesFromPreviewPaths = (previewPathsStr, fileNamesStr) => {
    const paths = String(previewPathsStr || '')
      .split('|')
      .map((s) => s.trim())
      .filter(Boolean);
    const displayNames = String(fileNamesStr || '')
      .split('|')
      .map((s) => s.trim());

    return paths.map((fullPath, i) => {
      const previewUrl = fullPath
        ? Global.file.useUrl + 'files/' + Commons.EncodeUrl(fullPath)
        : '';
      const fallbackName = fullPath.split(/[/\\]/).pop() || '';
      return {
        fileName: displayNames[i] || fallbackName,
        previewFilePath: fullPath,
        previewUrl,
      };
    });
  };

  const getKey = (r) => r?.no ?? r?.nearMissSeq ?? r?.id;

  const {
    SaveLogicFile: SaveLogicFilePre,
    DeleteLogicFile: DeleteLogicFilePre,
  } = useFileUpload({
    oldFilePathField: 'preFilePath',
    newFileNameField: 'saveName',
    getTargetPath: (_item, custCd) =>
      `AccidentStatus/${custCd || ''}/ACS_BASIC_02/Pre`,
  });
  const {
    SaveLogicFile: SaveLogicFilePost,
    DeleteLogicFile: DeleteLogicFilePost,
  } = useFileUpload({
    oldFilePathField: 'postFilePath',
    newFileNameField: 'saveName',
    getTargetPath: (_item, custCd) =>
      `AccidentStatus/${custCd || ''}/ACS_BASIC_02/Post`,
  });
  //#endregion

  const { handlePartialRefresh } = usePartialRefresh({
    gridRef: gridRef1,
    changedRowData: changedRowData1,
    setChangedRowData: setChangedRowData1,
    setRowData: setRowData1,
    getKeyFromRow: (row) => getKey(row),
    getKeyFromResult: (result) => result?.NearMissSeq ?? getKey(result),
  });

  useEffect(() => {
    if (saveClick1) {
      gridRef1?.current?.api?.stopEditing?.();
      Save1();
      setSaveClick1(false);
    }
    if (printClick1) {
      if (!validateSelection()) {
        setPrintClick1(false);
        return;
      }
      PrintLogic1();
      setPrintClick1(false);
    }
  }, [saveClick1, printClick1]);

  useEffect(() => {
    if (!searchClick1) return;
    ResetLogic();

    if (!searchInfo?.custCd) {
      setSearchClick1(false);
      return;
    }

    if (!validateSelection()) {
      setSearchClick1(false);
      return;
    }

    SearchLogic1();
    setSearchClick1(false);
  }, [searchClick1]);

  const searchKey = [
    searchInfo?.custCd,
    searchInfo?.depCd,
    gongjongCd ?? '',
    searchInfo?.year,
    searchInfo?.month,
    searchInfo?.gubun,
  ];

  const { refetch: Search1 } = useSearch1({
    searchKey,
    onSuccess: (rows) => {
      const mapped = (rows || [])
        .map(mapGetAcsBasic02R1RowToGrid)
        .filter(Boolean);
      setRowData1(mapped);
    },
    getSearchContext: () => ({
      search: { ...searchInfo, gongjongCd: gongjongCd ?? '' },
    }),
  });

  const delete1 = useDelete1();
  const deleteHandler1 = useDelete({
    gridRef: gridRef1,
    deleteMutation: delete1,
    updateDeleted: setDeletedRowData1,
    updateRowData: setRowData1,
    deletedRowData: deletedRowData1,
    rowData: rowData1,
    setChangedRowData: setChangedRowData1,
  });

  const { runAsync: Save1Async } = useSave1();
  const { run: Save1 } = useSave({
    menuId: SCREEN_MENU_ID,
    requiredLabel: '부서, 성명, 공정, 상황',
    schema: { fields: RIN_DAI_Schema.fields },
    getChangedRows: () => {
      const result = [];
      gridRef1?.current?.api?.forEachNode?.((node) => {
        const d = node?.data;
        if (!d) return;
        if (d.deleteYn === 'Y') return;
        if (d.editYn === 'Y') {
          result.push({ ...d });
        }
      });
      return result;
    },
    getDeletedRows: () => deletedRowData1,
    requestDelete: deleteHandler1.DeleteLogic,
    requestSave: Save1Async,
    fileDelete: async (deletedRowsToDelete) => {
      const custCd = searchInfo?.custCd || '';
      for (const row of deletedRowsToDelete) {
        const preFolder =
          row.preFilePath || `AccidentStatus/${custCd}/ACS_BASIC_02/Pre`;
        const preSaveNames = (row.preSaveName || row.preFileNames || '')
          .split('|')
          .filter(Boolean);
        if (preSaveNames.length) {
          const preItems = preSaveNames.map((saveName) => ({
            preFilePath: `${preFolder}/${saveName}`,
          }));
          await DeleteLogicFilePre(preItems);
        }
        const postFolder =
          row.postFilePath || `AccidentStatus/${custCd}/ACS_BASIC_02/Post`;
        const postSaveNames = (row.postSaveName || row.postFileNames || '')
          .split('|')
          .filter(Boolean);
        if (postSaveNames.length) {
          const postItems = postSaveNames.map((saveName) => ({
            postFilePath: `${postFolder}/${saveName}`,
          }));
          await DeleteLogicFilePost(postItems);
        }
      }
    },
    fileSave: async (changedRows) => {
      const custCd = searchInfo?.custCd || '';
      for (const row of changedRows) {
        if (row.prePreviewFilePaths && row.preSaveName) {
          const paths = String(row.prePreviewFilePaths)
            .split('|')
            .filter(Boolean);
          const names = String(row.preSaveName).split('|').filter(Boolean);
          const preItems = paths
            .slice(0, names.length)
            .map((path, i) => ({
              previewFilePath: path,
              saveName: names[i] ?? '',
            }))
            .filter((it) => it.saveName);
          if (preItems.length) {
            await SaveLogicFilePre(preItems, custCd);
          }
        }
        if (row.postPreviewFilePaths && row.postSaveName) {
          const paths = String(row.postPreviewFilePaths)
            .split('|')
            .filter(Boolean);
          const names = String(row.postSaveName).split('|').filter(Boolean);
          const postItems = paths
            .slice(0, names.length)
            .map((path, i) => ({
              previewFilePath: path,
              saveName: names[i] ?? '',
            }))
            .filter((it) => it.saveName);
          if (postItems.length) {
            await SaveLogicFilePost(postItems, custCd);
          }
        }
      }
    },
    onSuccessRefresh: () => SearchLogic1(),
    partialRefresh: async ({ saveResult, changedRows }) => {
      await handlePartialRefresh({
        saveResult,
        changedRows,
        searchLogic: SearchLogic1,
      });
    },
  });

  const ResetLogic = () => {
    setRowData1([]);
    setSelectedRowData1([]);
    setChangedRowData1([]);
    setDeletedRowData1([]);
    gridRef1?.current?.api?.deselectAll?.();
  };

  const SearchLogic1 = async () => {
    ResetLogic();
    if (!validateSelection()) return;
    await Search1();
  };

  const MarkedForDeletion1 = (rowsToMark) => {
    if (!rowsToMark?.length) return;
    const keySet = new Set(rowsToMark.map((r) => getKey(r)));
    setRowData1((prev) => {
      const newRowData = prev.map((row) =>
        keySet.has(getKey(row)) ? { ...row, deleteYn: 'Y' } : row
      );
      gridRef1?.current?.api?.setRowData?.(newRowData);
      return newRowData;
    });
    setChangedRowData1((prev) => {
      const filtered = prev.filter((r) => !keySet.has(getKey(r)));
      const updated = rowsToMark.map((r) => ({
        ...r,
        deleteYn: 'Y',
        editYn: 'Y',
      }));
      return [...filtered, ...updated];
    });
    setDeletedRowData1((prev) => {
      const filtered = prev.filter((r) => !keySet.has(getKey(r)));
      const toAdd = rowsToMark.map((r) => ({
        ...r,
        deleteYn: 'Y',
        editYn: 'Y',
      }));
      return [...filtered, ...toAdd];
    });
  };

  const NewYnErrorMsg = () => {
    dispatch(
      showSnackbar({
        message: '데이터 입력중입니다. 저장 후 시도하세요.',
        type: 'warning',
      })
    );
  };

  const updateGridRowForMember = (rowNode, selected, target) => {
    const depLevels = [
      selected.depNm4,
      selected.depNm3,
      selected.depNm2,
      selected.depNm1,
    ];
    const depNm =
      depLevels.find((v) => v != null && String(v).trim() !== '') ?? '';
    const base = { ...rowNode.data, editYn: 'Y' };
    const updatedData =
      target === 'managerNm'
        ? {
            ...base,
            managerId: selected.id ?? '',
            managerNm: selected.name ?? '',
          }
        : {
            ...base,
            discovererId: selected.id ?? '',
            discovererNm: selected.name ?? '',
            depNm,
            rank: selected.rank ?? '',
          };
    rowNode.setData(updatedData);
    const key = getKey(updatedData);
    setChangedRowData1((prev) => {
      const filtered = prev.filter((r) => getKey(r) !== key);
      return [...filtered, updatedData];
    });
    setRowData1((prev) => {
      const list = prev || [];
      const existing = list.find((r) => getKey(r) === key);
      if (!existing) return [updatedData, ...list];
      return list.map((r) =>
        getKey(r) !== key ? r : { ...r, ...updatedData }
      );
    });
    const api = gridRef1?.current?.api;
    if (api) {
      api.setFocusedCell(
        rowNode.rowIndex,
        target === 'managerNm' ? 'managerNm' : 'discovererNm'
      );
    }
  };

  const HandleManageSelection1 = (selected) => {
    if (!selected) return;
    const api = gridRef1?.current?.api;
    if (!api) return;
    const { rowIndex, target } = rowClickData.current ?? {};
    let rowNode =
      rowIndex !== undefined ? api.getDisplayedRowAtIndex(rowIndex) : null;
    if (!rowNode) {
      const allNodes = [];
      api.forEachNode((node) => allNodes.push(node));
      const newRows = allNodes.filter((n) => n.data?.newYn === 'Y');
      rowNode = newRows[newRows.length - 1];
    }
    if (rowNode)
      updateGridRowForMember(rowNode, selected, target || 'discovererNm');
    rowClickData.current = null;
    setModalToggle1(false);
  };

  const PopupClickEvent1 = (e) => {
    rowClickData.current = {
      rowIndex: e.rowIndex,
      data: e.data,
      target: e.colDef.field === 'managerNm' ? 'managerNm' : 'discovererNm',
    };
    setModalToggle1(true);
  };

  const PopupGongjongClickEvent1 = (params) => {
    gongjongRowDataRef.current = {
      rowIndex: params.rowIndex,
      data: params.data,
    };
    setGongjongModalToggle(true);
  };

  const HandleGongjongSelection1 = ({ gongjongCd: gjCd, gongjongNm }) => {
    const api = gridRef1?.current?.api;
    if (!api) return;
    const { rowIndex } = gongjongRowDataRef.current ?? {};
    const rowNode =
      rowIndex !== undefined ? api.getDisplayedRowAtIndex(rowIndex) : null;
    if (!rowNode) return;
    const updatedData = {
      ...rowNode.data,
      gongjongCd: gjCd ?? '',
      gongjongNm: gongjongNm ?? '',
      editYn: 'Y',
    };
    rowNode.setData(updatedData);
    const key = getKey(updatedData);
    setChangedRowData1((prev) => {
      const filtered = prev.filter((r) => getKey(r) !== key);
      return [...filtered, updatedData];
    });
    setRowData1((prev) => {
      const list = prev || [];
      const existing = list.find((r) => getKey(r) === key);
      if (!existing) return list;
      return list.map((r) =>
        getKey(r) !== key ? r : { ...r, ...updatedData }
      );
    });
    gongjongRowDataRef.current = null;
    setGongjongModalToggle(false);
  };

  const handleRowSelection1 = (rowData, rowIndex) => {
    lastCheckedIndexRef1.current = rowIndex;
    setSelectedRowData1([rowData]);
  };

  const RestoreRow1 = (row) => deleteHandler1.RestoreRow(row);
  const DeleteNewRow1 = (row) => deleteHandler1.DeleteNewRow(row);

  const PrintLogic1 = async () => {
    dispatch(showLoadingAction());
    try {
      const toPrint = (rowData1 || []).filter((r) => r.deleteYn !== 'Y');
      if (!toPrint.length) {
        dispatch(
          showSnackbar({
            message: '인쇄할 데이터가 없습니다.',
            type: 'warning',
          })
        );
        dispatch(closeLoadingAction());
        return;
      }
      const printData = {
        FileName: 'ACS_BASIC_02',
        HeaderData: JSON.stringify({ title: '위험감지·아차사고' }),
        TableData: JSON.stringify(toPrint),
      };
      await Commons.Axios(
        'report',
        Global.base.useUrl + Global.urls.Reports.reports,
        printData
      ).then((response) => {
        const blobUrl = URL.createObjectURL(response.data);
        window.open(blobUrl, '_blank');
      });
    } catch (e) {
      dispatch(
        showSnackbar({
          message: e?.message || '인쇄 중 오류가 발생했습니다.',
          type: 'error',
        })
      );
    } finally {
      dispatch(closeLoadingAction());
    }
  };

  const ExcelDownload1 = async () => {
    try {
      const api = gridRef1?.current?.api;
      if (!api) return;

      const excludeFromExcel = ['preFileNames', 'postFileNames'];
      const columnState = api.getColumnState?.() ?? [];
      const columnKeys = columnState
        .filter((col) => col.colId && !excludeFromExcel.includes(col.colId))
        .map((col) => col.colId);

      const fileName = `${dayjs().format('YYYYMMDDHHmm')}위험감지·아차사고.xlsx`;
      api.exportDataAsExcel({
        fileName,
        ...(columnKeys.length > 0 ? { columnKeys } : {}),
      });
    } catch (error) {
      dispatch(
        showSnackbar({
          message: error?.message || '엑셀 다운로드 중 오류가 발생했습니다.',
          type: 'error',
        })
      );
    }
  };

  const openPreImageModal = (rowData) => {
    if (!rowData) return;
    preImageRowRef.current = { key: getKey(rowData) };
    let initial;
    if (rowData.images?.length > 0) {
      initial = buildInitialFilesFromImages(rowData.images, 'PRE');
    } else if (String(rowData.prePreviewFilePaths || '').trim()) {
      initial = buildInitialFilesFromPreviewPaths(
        rowData.prePreviewFilePaths,
        rowData.preFileNames
      );
    } else {
      initial = buildInitialFilesFromRow(
        rowData.preFilePath,
        rowData.preFileNames,
        rowData.preSaveName,
        'Pre'
      );
    }
    setPreImageInitialFiles(initial);
    setPreImageModalOpen(true);
  };

  const openPostImageModal = (rowData) => {
    if (!rowData) return;
    postImageRowRef.current = { key: getKey(rowData) };
    let initial;
    if (rowData.images?.length > 0) {
      initial = buildInitialFilesFromImages(rowData.images, 'POST');
    } else if (String(rowData.postPreviewFilePaths || '').trim()) {
      initial = buildInitialFilesFromPreviewPaths(
        rowData.postPreviewFilePaths,
        rowData.postFileNames
      );
    } else {
      initial = buildInitialFilesFromRow(
        rowData.postFilePath,
        rowData.postFileNames,
        rowData.postSaveName,
        'Post'
      );
    }
    setPostImageInitialFiles(initial);
    setPostImageModalOpen(true);
  };

  const handlePreImageSave = async (files) => {
    const ref = preImageRowRef.current;
    if (!ref?.key) return;
    const api = gridRef1?.current?.api;
    if (!api) return;
    let rowNode = null;
    api.forEachNode((node) => {
      if (!rowNode && getKey(node.data) === ref.key) {
        rowNode = node;
      }
    });
    if (!rowNode) return;

    const ts = dayjs().format('YYYYMMDDHHmmss');
    const fileNames = files.map((f) => f.fileName || 'image').join('|');
    const saveNames = files
      .map((f, i) => {
        const baseName = (f.fileName || 'image').replace(/^.*[/\\]/, '');
        return `${ts}_${i}_${baseName}`;
      })
      .join('|');
    const prePreviewFilePaths = files.map((f) => f.previewFilePath).join('|');
    const preFolderPath = `AccidentStatus/${searchInfo?.custCd}/ACS_BASIC_02/Pre`;

    const updatedData = {
      ...rowNode.data,
      preFileNames: fileNames,
      preFilePath: preFolderPath,
      preSaveName: saveNames,
      prePreviewFilePaths,
      editYn: 'Y',
    };
    rowNode.setData(updatedData);
    const key = getKey(updatedData);
    setChangedRowData1((prev) => {
      const filtered = prev.filter((r) => getKey(r) !== key);
      return [...filtered, updatedData];
    });
    setRowData1((prev) => {
      const list = prev || [];
      const existing = list.find((r) => getKey(r) === key);
      if (!existing) return list;
      return list.map((r) =>
        getKey(r) !== key ? r : { ...r, ...updatedData }
      );
    });
    preImageRowRef.current = null;
  };

  const handlePostImageSave = async (files) => {
    const ref = postImageRowRef.current;
    if (!ref?.key) return;
    const api = gridRef1?.current?.api;
    if (!api) return;
    let rowNode = null;
    api.forEachNode((node) => {
      if (!rowNode && getKey(node.data) === ref.key) {
        rowNode = node;
      }
    });
    if (!rowNode) return;

    const ts = dayjs().format('YYYYMMDDHHmmss');
    const fileNames = files.map((f) => f.fileName || 'image').join('|');
    const saveNames = files
      .map((f, i) => {
        const baseName = (f.fileName || 'image').replace(/^.*[/\\]/, '');
        return `${ts}_${i}_${baseName}`;
      })
      .join('|');
    const postPreviewFilePaths = files.map((f) => f.previewFilePath).join('|');
    const postFolderPath = `AccidentStatus/${searchInfo?.custCd}/ACS_BASIC_02/Post`;

    const updatedData = {
      ...rowNode.data,
      postFileNames: fileNames,
      postFilePath: postFolderPath,
      postSaveName: saveNames,
      postPreviewFilePaths,
      editYn: 'Y',
    };
    rowNode.setData(updatedData);
    const key = getKey(updatedData);
    setChangedRowData1((prev) => {
      const filtered = prev.filter((r) => getKey(r) !== key);
      return [...filtered, updatedData];
    });
    setRowData1((prev) => {
      const list = prev || [];
      const existing = list.find((r) => getKey(r) === key);
      if (!existing) return list;
      return list.map((r) =>
        getKey(r) !== key ? r : { ...r, ...updatedData }
      );
    });
    postImageRowRef.current = null;
  };

  const setSaveClick1Sync = (v) => flushSync(() => setSaveClick1(v));

  useEffect(() => {
    if (!executed.current && searchInfo.custCd) {
      setSearchClick1(true);
      executed.current = true;
    }
  }, [searchInfo.custCd]);

  useEffect(() => {
    if (searchInfo.custCd) {
      fetchDepForCust(searchInfo.custCd);
    }
  }, [searchInfo.custCd, fetchDepForCust]);

  useEffect(() => {
    fetchGongjongForDep(searchInfo.depCd ?? '');
  }, [searchInfo.depCd, fetchGongjongForDep]);

  return (
    <div className="wrap">
      <RIN_DAI
        userInfo={userInfo}
        searchInfo={searchInfo}
        dispatch={dispatch}
        handleCoChange={handleCoChange}
        handleCustChange={handleCustChange}
        handleDepChange={(e) => handleDepChange(e?.target?.value ?? e)}
        handleYearMonthChange={handleYearMonthChange}
        gongjongList={gongjongList}
        gongjongCd={gongjongCd}
        handleGongjongChange={handleGongjongChange}
        setSearchText={(text) => dispatch(setSearchText(text))}
        validateSelection={validateSelection}
        searchClick1={searchClick1}
        setSearchClick1={setSearchClick1}
        saveClick1={saveClick1}
        setSaveClick1={setSaveClick1Sync}
        printClick1={printClick1}
        setPrintClick1={setPrintClick1}
        gridRef1={gridRef1}
        rowData1={rowData1}
        setRowData1={setRowData1}
        selectedRowData1={selectedRowData1}
        setSelectedRowData1={setSelectedRowData1}
        changedRowData1={changedRowData1}
        setChangedRowData1={setChangedRowData1}
        modalToggle1={modalToggle1}
        setModalToggle1={setModalToggle1}
        gongjongModalToggle={gongjongModalToggle}
        setGongjongModalToggle={setGongjongModalToggle}
        custCd={searchInfo?.custCd}
        rowClickData={rowClickData}
        HandleManageSelection1={HandleManageSelection1}
        PopupClickEvent1={PopupClickEvent1}
        PopupGongjongClickEvent1={PopupGongjongClickEvent1}
        HandleGongjongSelection1={HandleGongjongSelection1}
        handleRowSelection1={handleRowSelection1}
        ExcelDownload1={ExcelDownload1}
        PopupPreImageClickEvent1={openPreImageModal}
        PopupPostImageClickEvent1={openPostImageModal}
        SearchLogic1={SearchLogic1}
        MarkedForDeletion1={MarkedForDeletion1}
        NewYnErrorMsg={NewYnErrorMsg}
        RestoreRow1={RestoreRow1}
        DeleteNewRow1={DeleteNewRow1}
        selectedRowNosRef1={selectedRowNosRef1}
        lastCheckedIndexRef1={lastCheckedIndexRef1}
      />
      <FileUploadMultiDialog
        open={preImageModalOpen}
        title="개선 전 사진 첨부"
        onClose={() => setPreImageModalOpen(false)}
        onSave={handlePreImageSave}
        initialFiles={preImageInitialFiles}
      />
      <FileUploadMultiDialog
        open={postImageModalOpen}
        title="개선 후 사진 첨부"
        onClose={() => setPostImageModalOpen(false)}
        onSave={handlePostImageSave}
        initialFiles={postImageInitialFiles}
      />
    </div>
  );
}

export default RIN_DAIF;
